import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FormControl, InputLabel, MenuItem, Select, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function SetIdsDialog({
    open,
    handleClose,
    plans,
    onSubmit
  }) {

    const { t } = useTranslation();
    const handleSubmit = (e) => {
        e.preventDefault()
        const ids = []
        for (const el of e.target){
          if(el.id){
            ids.push({
              id: el.id,
              value: el.value
            })
          }
        }
        onSubmit(ids)
    }

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="300px"
      >
        <DialogTitle>{t("views.productsManager.setProductsIds")}</DialogTitle>
        <Box component="form" sx={{
                display:'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '20px'
            }} onSubmit={handleSubmit} onReset={handleClose}>
            <DialogContent>
                <DialogContentText>
                    {t("views.productsManager.enterStripeIds")}
                </DialogContentText>
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '20px',
                  mt: 4
                }}>
                    {plans.map(p => {
                        return (
                          !p.hidden && p.paid ? (
                            <TextField required variant='outlined' placeholder='Enter ID' id={p._id} label={`${p.name} #ID`} fullWidth name='prid' defaultValue={p.productId} focused/>
                          ) : null
                        )
                    })}
                </Box>
            </DialogContent>
            <DialogActions sx={{
              alignSelf: 'end'
            }}>
                <Button type='reset'>{t("views.productsManager.cancel")}</Button>
                <Button type="submit" color="success">{t("views.productsManager.save")}</Button>
            </DialogActions>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}